import { render, staticRenderFns } from "./business-home-page.vue?vue&type=template&id=204ba304&"
import script from "./business-home-page.vue?vue&type=script&lang=js&"
export * from "./business-home-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports